export const site = {
  brand: '吃瓜福利社',
  brandShort: '吃瓜社',
  slogan: '按档期追瓜，福利不错过',
  intro:
    '吃瓜福利社是一个以「福利吃瓜」为核心的娱乐热点门户，把每天正在发酵的话题、每周值得花时间的内容、以及只在周末与假日上线的特别企划，按档期整理在一起。我们不做信息的搬运工，而是帮你把节奏理清楚。',
  email: 'hello@chiguafulishe.cn',
  weibo: '吃瓜福利社',
  updated: '2026-09-10',
};

export const navLinks = [
  { label: '首页', to: '/' },
  { label: '瓜料库', to: '/topics' },
  { label: '常见问题', to: '/faq' },
  { label: '关于我们', to: '/about' },
];

export const stats = [
  { value: '5', label: '档期栏目' },
  { value: '1200+', label: '累计瓜料' },
  { value: '每日 2 轮', label: '上新节奏' },
  { value: '30万+', label: '订阅读者' },
];